<template lang="pug">
  main
    NavBar
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Nueva Asignación Mensual&nbsp
              |
              a.button.is-black.is-rounded(@click="backPage")
                i.fas.fa-times
        .columns
          .column.is-12
            Form_AsigMensual(:abonos="abonos" :usuarios="usuarios" :tarjetas="tarjetas" @saveForm="saveForm")
        .columns(v-show="verNotificacionTarjeta")
          .column.is-offset-4.is-4
            .notificacion.is-light
              strong No hay Tarjetas asignadas para éste usuario.
        .columns.column-blanco
</template>

<script>
  import NavBar from './layout/NavBarTransportes.vue'
  import Form_AsigMensual from './componentes/Form_AsigMensual.vue'
  import Loader from '@/components/shared/Loader.vue'
  import usuariosServices from '@/services/usuarios/usuarios'
  import InventarioServices from '@/services/inventario/inventario'
  
  export default {
    name: 'NewAsignacion',
    components: { NavBar, Loader, Form_AsigMensual },
    data() {
      return {
        isLoading: true,
        usuarios: [],
        tarjetas: [],
        vehiculos: [],
        tarjetasSel: [],
        abonos: [],
        verNotificacionTarjeta: false,
      }
    },
    methods: {
      iniciarComponente() {
        this.obtenerAbonos()
      },
      obtenerAbonos() {
        InventarioServices.getAbonos()
          .then((data) => {
            this.abonos = data.map(this.convertirAbonos)
            this.obtenerUsuarios()
          })
          .catch((e) => console.log(e))
      },
      obtenerUsuarios() {
        usuariosServices.getUsuarios()
          .then( (res) => {
            let users = res.filter(user => user.id !== '1538165924968' && user.id !== '1565972235101' && user.id !== '1556122430935' && user.id !== '1539965959482' && parseInt(user.categoria) < 4)
            this.usuarios = users
          })
          .catch((e) => console.log(e))
          this.obtenerTarjetas()
      },
      obtenerTarjetas() {
        InventarioServices.getTarjetas()
          .then((data) => {
            this.tarjetas = data
          })
          .catch((e) => console.log(e))
        this.isLoading = false  
      },
      saveForm(f) {
        InventarioServices.addComb_AsignacionMensual(f.fechaReg, f.fechaMov, f.periodo, f.ubicacion, f.area, f.idE, f.ent, f.idRec, f.rec, f.idA, f.noT, f.cant, f.extra)
          .then( (data) => {
            console.log(data)
            if (data.success) {
              this.displayToast(data.respuesta, 'done', 'OK')
              this.backPage()
            } else {
              this.displayToast(data.respuesta, 'ban', 'OK')
            }
          })
          .catch( (e) => {
            this.isLoading = false
            this.displayToast(e.message, 'ban', 'OK')
          })
      },
      displayToast(text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: "toasted-primary", 
          position: "bottom-right", 
          duration : null,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
      backPage () {
        this.$router.back()
      },
      convertirAbonos(a) {
        return {
          ...a,
          abono: Number(a.abono),
          cargo: Number(a.cargo),
          id: parseInt(a.id),
          id_articulo: parseInt(a.id_articulo),
          id_comercio: parseInt(a.id_comercio),
          id_respuesta: parseInt(a.id_respuesta),
          id_ticket: parseInt(a.id_ticket),
          id_tarjeta: parseInt(a.id_tarjeta),
          tipo: parseInt(a.tipo),
          transaccion: parseInt(a.transaccion),
        }
      },
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="scss" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/NewAsignacion.vue